import { createSelector } from "reselect";

const allBase = state => state.funnels.all;
export const isLoadingAll = createSelector( allBase, all => all.loading );
export const listAll = createSelector( allBase, all => all.data );